import React, { useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
export interface Props {setData : Function}
export const EquipmentStatus:React.FC<Props> = ({setData}) => {
    const {t} = useTranslation()
    const location = useLocation()
    const path = location.pathname.split('/')
    const [state, setState] = useState<number>(1)
    useLayoutEffect(()=>{
        switch(path[1]){
            case 'equipmentStatus' : setData((prev:any)=>({...prev, title_2_kr : '설비현황', title_2_en : 'Equipment Status', classNameName_2 : ''})); break;
        }
    }, [location])
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left stickyBox">
                    <h3>
                        <span>{t("equipment_status_1")}</span>
                        {t("equipment_status_2")}
                    </h3>
                    <ul className="tabBtnBox">
                        <li className={state === 1?'active':''} onClick={()=>setState(1)}>{t("equipment_status_3")}</li>
                        <li className={state === 2?'active':''} onClick={()=>setState(2)}>{t("equipment_status_4")}</li>
                        <li className={state === 3?'active':''} onClick={()=>setState(3)}>{t("equipment_status_5")}</li>
                    </ul>
                </div>
                <div className="right">
                    <ul>
                        <li className={state === 1?'active':''}>
                            <div className="imgBox">
                                <img src="/assets/images/equipment_status_1.png" alt="다이나모"/>
                            </div>
                            <div className="tableBox">
                                <div>
                                    <span>{t("equipment_status_6")}</span>
                                    <span>{t("equipment_status_7")}</span>
                                </div>
                                <div>
                                    <span>{t("equipment_status_8")}</span>
                                    <span>1750PS / 100PS</span>
                                </div>
                            </div>
                        </li>
                        <li className={state === 2?'active':''}>
                            <div className="imgBox">
                                <img src="/assets/images/equipment_status_1.png" alt="다이나모"/>
                            </div>
                            <div className="tableBox">
                                <div>
                                    <span>{t("equipment_status_6")}</span>
                                    <span>{t("equipment_status_4")}</span>
                                </div>
                                <div>
                                    <span>{t("equipment_status_8")}</span>
                                    <span>1200kW</span>
                                </div>
                            </div>
                            {/* <!-- 발전기 로드테스터 표 --> */}
                        </li>
                        <li className={state === 3?'active':''}>
                            <div className="imgBox">
                                <img src="/assets/images/equipment_status_1.png" alt="다이나모"/>
                            </div>
                            <div className="tableBox">
                                <div>
                                    <span>{t("equipment_status_6")}</span>
                                    <span>{t("equipment_status_5")}</span>
                                </div>
                                <div>
                                    <span>{t("equipment_status_8")}</span>
                                    <span>-</span>
                                </div>
                            </div>
                            {/* <!-- 도장부스 표 --> */}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        </>
    )
}